import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class HeaderProcessingInterceptor implements HttpInterceptor {

  constructor() {

  }
  master = (window as any).Master;
  app = (window as any).app;
  isLimsHosted = !ConfigurationService.isLimsHosted;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //Add PUID to header
    let modified = request;
    
    if(this.master !== null && this.master !== undefined){
      return from(this.getOauthToken(request.url)).pipe(
        switchMap((authHeader) => {
          //if (authHeader !== undefined && authHeader) {
            modified = request.clone({
              setHeaders: {
                ...this.getApiIdentityCommonHeaders(),
                Authorization: `Bearer ${authHeader}`
              }
            });
          //}
          return next.handle(modified);
        })
      );
    }else{
      if(sessionStorage.getItem("puid") !== null){
        modified = request.clone({
          setHeaders: {
            ...this.getApiIdentityCommonHeaders(),
            'puid': sessionStorage.getItem("puid")!.toUpperCase()
          }
        });
        return next.handle(modified);
      }
      return next.handle(request);
    }
  }

  private getApiIdentityCommonHeaders(): {
    'X-User-Puid'?: string;
    'X-User-LabsiteCode'?: string;
  } {
      if(ConfigurationService.isLimsHosted){
         if(sessionStorage.getItem("puid") === null){
         sessionStorage.setItem("puid", (this.master.currentUser.Puid as string)?.toUpperCase());
        }
        return {
          'X-User-Puid': (this.master.currentUser.Puid as string)?.toUpperCase(),
          'X-User-LabsiteCode': this.master.currentUser.labSiteCode ?? ''
        }
      }else{
        let puid="";
        if(sessionStorage.getItem("puid") !== null){
          puid = sessionStorage.getItem("puid")!;
        }
        return {
          'X-User-Puid': puid.toUpperCase(),
          'X-User-LabsiteCode': ""          
        };
      }
    return {};
  }

  getOauthToken(url: string): Promise<string> {
      return new this.master.OauthTokenProvider().getOauthToken(url);
  }

  addpuidHeaders(request: HttpRequest<any>, puid: string): HttpRequest<any> {
    const modified = request.clone({
      setHeaders: {
        'puid': puid.toUpperCase()
      }
    });

    return modified;
  }
}
